import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { generalActions } from "../actions";
import store from "..";

function isTokenAboutToExpire(expiryTime) {
  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds since epoch
  const timeRemaining = expiryTime - currentTime;
  return timeRemaining <= 1800 && timeRemaining > 0;
}

function isTokenExpired(expiryTime) {
  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds since epoch
  const timeRemaining = expiryTime - currentTime;
  return timeRemaining < 0;
}

axios.interceptors.response.use(
  async (response) => {
    // const accessToken = localStorage?.getItem("accessToken");
    // const refreshToken = localStorage?.getItem("refreshToken");
    // const decodedToken = accessToken !== null && jwtDecode(accessToken);

    // if (isTokenAboutToExpire(decodedToken?.exp)) {
    //   const payload = JSON.stringify({
    //     accessToken: accessToken?.replace(/"/g, ""),
    //     refreshToken: refreshToken?.replace(/"/g, ""),
    //   });
    //   const headers = {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${accessToken?.replace(/"/g, "")}`,
    //   };

    //   const response = await fetch(
    //     `${process.env.REACT_APP_API_URL}token/refresh`,
    //     {
    //       method: "POST",
    //       headers: headers,
    //       body: payload,
    //     }
    //   );

    //   let data = {};
    //   if (response) {
    //     data = await response?.json();
    //   }

    //   localStorage.setItem("accessToken", data?.accessToken);
    //   localStorage.setItem("refreshToken", data?.refreshToken);
    // }

    return response;
  },

  (error) => {
    const accessToken = localStorage?.getItem("accessToken");
    if (accessToken) {
      const decodedToken = jwtDecode(accessToken);

      if (isTokenExpired(decodedToken?.exp)) {
        store.dispatch(
          generalActions.showToast({
            title: "Your session has expired. Please login again.",
            type: "error",
          })
        );
        window.location.href = "/";
        if (
          error?.response &&
          (error?.response?.status === 401 || error?.response?.status === 403)
        ) {
          const user = localStorage.getItem("user");
          if (user) {
            localStorage.clear();
          }
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
